import { Trans } from 'react-i18next';
import { BenefitAttribute, BenefitColumnsExtensionInterface } from '../../../../extension/interface/benefit-columns.extension.interface';

export class CouponsV2BenefitColumnsExtension extends BenefitColumnsExtensionInterface {
  getBenefitAttributes: () => BenefitAttribute[] = () => [
    {
      id: 'couponsV2MonthlyBudget',
      accessorFn: value => value.couponsV2Options?.monthlyBudget,
      header: 'COUPONS_V2.fields.monthlyBudget',
      renderer: value => (typeof value === 'number' ? <Trans i18nKey="common:money" values={{ money: value }} /> : null),
    },
  ];
}
